import './ScrollablePageWrapper.css';

const ScrollablePageWrapper = ({ children, mobileOnly }) => (
  <div className={`${mobileOnly ? ' scrollable-page-wrapper--mobile-only' : 'scrollable-page-wrapper'}`}>
    {children}
  </div>
);

export { ScrollablePageWrapper };
